import { CreateFlowcodeReturnType } from '@dtx-company/app/shared/code/src/components/Homepage/CreateFlowcodeForm/CreateFlowcodeForm.types'
import { createCode } from '@dtx-company/app/shared/code/src/components/Homepage/CreateFlowcodeForm/CreateFlowcodeFormDesktop/CreateFlowcodeFormDesktop.hooks'
import { logger } from '@dtx-company/logger'
import { useCallback } from 'react'
import { useGetCachedLOCGFormValues } from './useGetCachedLOCGFormValues'

type CreateCodeAfterAuthRedirect = (token: string) => Promise<CreateFlowcodeReturnType | undefined>

export function useCreateCodeAfterAuthRedirect(): CreateCodeAfterAuthRedirect {
  const getCachedLOCGFormValues = useGetCachedLOCGFormValues()

  return useCallback<CreateCodeAfterAuthRedirect>(
    async token => {
      try {
        const args = await getCachedLOCGFormValues()
        if (!args) return
        return createCode({ ...args, token })
      } catch (e) {
        logger.logError(e, { technicalArea: 'authentication' })
      }
    },
    [getCachedLOCGFormValues]
  )
}
